// Import API and web components
import './builder/core';
import './builder/components';

// We will improve the folder structure as we add components
import '@builder-legacy/item/conditions/components';
import '@builder-legacy/user-selector/components';

// Load walkthrough
import '@builder-legacy/walkthrough';

// Load static resources
import './scss/main.scss';

// Create JS cache object
UncannyAutomator._cache = {
	tokens: {},
};

import {
	createDataOnLoad,
	handleFatalError,
	renderCantEditDialog
}   from './js/common/utilities.js';

import Publish            from './js/publish/publish.js';

import Triggers           from './js/item/triggers.js';
import Actions            from './js/item/actions.js';

import SendFeedback       from './js/send-feedback/send-feedback.js';

import RecipeTitle        from './js/recipe/title';

import Taxonomies         from './js/taxonomies/taxonomies.js';

import RecipeNotes        from './js/recipe/notes';

if ( 
	_uo.utility.isDefined( UncannyAutomator._recipe.miscellaneous.can_edit ) && 
	! UncannyAutomator._recipe.miscellaneous.can_edit 
) {
	renderCantEditDialog();
} else {
	// Create the data required to render Automator
	try {
		createDataOnLoad(() => {
			// Once ready, render the UI
			new Triggers();
			new Actions();
			new Publish();
			new SendFeedback();
			new RecipeTitle();
			new Taxonomies();
			new RecipeNotes();
		});
	} catch ( error ){
		// Show a modal with data in case the UI couldn't load
		handleFatalError({
			title:   UncannyAutomator._core.i18n.debugging.uiCantLoad.title,
			warning: UncannyAutomator._core.i18n.debugging.uiCantLoad.warning,
			content: UncannyAutomator._core.i18n.debugging.uiCantLoad.content,
			console: error
		});
	}
}

document.addEventListener( 'uap-builder-recipe-data-change', event => {
	console.log( 'uap-builder-recipe-data-change' );

	new Triggers();
	new Actions();
	new Publish();
} );

// Remove the "Changes you made may not be saved" WordPress alert
jQuery( document ).ready( () => {
	jQuery( window ).off( 'beforeunload.edit-post', null );
});